import * as React from 'react'
import { VenueClearEventsAction } from '@/components/VenueClearEventsAction'
import { VenueDeleteAction } from '@/components/VenueDeleteAction'
import type { VenueDto } from '@lib/dto/venue.dto'

/**
 * The two things an organization can do to a venue that cannot be walked back:
 * empty its calendar, or archive the venue itself.
 *
 * Ordered by what survives. Clearing the calendar keeps the venue — it is how a
 * bad import is undone — while archiving keeps the events and retires the venue.
 * Both are organization decisions, which is why they live here rather than inside
 * the venue: see `VenueOrganizationSettings`.
 */
export function VenueDangerZone({
  venue,
  canClearEvents,
  canDelete,
}: {
  venue: VenueDto
  /** Clearing the venue's events: Delete events, on a Company-wide role. */
  canClearEvents: boolean
  /** Archiving the venue: Venues. */
  canDelete: boolean
}): React.ReactElement | null {
  if (!canClearEvents && !canDelete) return null
  return (
    <section id="danger" className="space-y-3 border-t border-line pt-8" aria-labelledby="danger-zone-heading">
      <div>
        <h2 id="danger-zone-heading" className="text-sm font-semibold text-danger-ink">
          Danger zone
        </h2>
        <p className="mt-0.5 text-sm text-ink-muted">
          Irreversible or high-impact actions for this venue.
        </p>
      </div>
      {canClearEvents ? <VenueClearEventsAction venue={venue} /> : null}
      {canDelete ? <VenueDeleteAction venue={venue} /> : null}
    </section>
  )
}
